import { X } from 'lucide-react';
import { DrawerClose } from '@herit-fe/heritage-ui';
import { UI_TEXT } from '@/shared/languages';
import { useIsCompact } from './use-is-compact';

/**
 * Drawer 우상단 닫기(X) 버튼 — **pc(right drawer)에서만** 노출. non-pc(bottom)은 상단 드래그 핸들 +
 * 드래그-닫기 제스처가 있어 생략(compact 판정은 direction 전환과 동일 경계라 정확히 일치).
 *
 * `DrawerContent`(position:fixed) 기준 absolute 우상단 배치라 헤더 레이아웃을 건드리지 않는다.
 * `DrawerClose`(vaul) 가 닫기 트리거를 담당.
 */
export function DrawerCloseButton() {
  const isCompact = useIsCompact();
  if (isCompact) return null;
  return (
    <DrawerClose
      aria-label={UI_TEXT.COMMON_CLOSE}
      className="absolute right-3 top-3 z-10 inline-flex size-8 items-center justify-center rounded-md text-muted-foreground transition-colors hover:bg-accent hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
    >
      <X className="size-4" aria-hidden="true" />
    </DrawerClose>
  );
}
